/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  LoyaltyRedemptionStatus,
  RewardScheduleContentUpdateRequest,
  RewardScheduleWithGame,
  RewardSchedulesWithGames,
  S2WGame,
  S2WGameUpdateRequest,
  SpinHealthWithGames,
  SpinHistoryAdminPage,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    LoyaltyRedemptionStatusFromJSON,
    LoyaltyRedemptionStatusToJSON,
    RewardScheduleContentUpdateRequestFromJSON,
    RewardScheduleContentUpdateRequestToJSON,
    RewardScheduleWithGameFromJSON,
    RewardScheduleWithGameToJSON,
    RewardSchedulesWithGamesFromJSON,
    RewardSchedulesWithGamesToJSON,
    S2WGameFromJSON,
    S2WGameToJSON,
    S2WGameUpdateRequestFromJSON,
    S2WGameUpdateRequestToJSON,
    SpinHealthWithGamesFromJSON,
    SpinHealthWithGamesToJSON,
    SpinHistoryAdminPageFromJSON,
    SpinHistoryAdminPageToJSON,
} from '../models/index';

export interface EndRewardScheduleEarlyRequest {
    scheduleId: string;
    customerId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface GetCurrentRewardSchedulesRequest {
    customerId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface GetSpinHealthRequest {
    customerId: string;
    windowHours: number;
    gameId?: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface GetSpinHistoryForPlayerRequest {
    playerLookupId: string;
    customerId: string;
    gameId?: string;
    status?: LoyaltyRedemptionStatus;
    resultStart?: number;
    resultEnd?: number;
    startDate?: Date;
    endDate?: Date;
    xClientID?: string;
    xRequestID?: string;
}

export interface UpdateRewardScheduleContentRequest {
    scheduleId: string;
    customerId: string;
    rewardScheduleContentUpdateRequest: RewardScheduleContentUpdateRequest;
    xClientID?: string;
    xRequestID?: string;
}

export interface UpdateS2WGameRequest {
    gameId: string;
    customerId: string;
    s2WGameUpdateRequest: S2WGameUpdateRequest;
    xClientID?: string;
    xRequestID?: string;
}

/**
 * 
 */
export class SpinToWinApi extends runtime.BaseAPI {

    /**
     * End a prize schedule that has started, effective now. Players stop receiving it immediately, and prizes that have not unlocked yet are never awarded.
     */
    async endRewardScheduleEarlyRaw(requestParameters: EndRewardScheduleEarlyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['scheduleId'] == null) {
            throw new runtime.RequiredError(
                'scheduleId',
                'Required parameter "scheduleId" was null or undefined when calling endRewardScheduleEarly().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling endRewardScheduleEarly().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:spin-to-win"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/spin-to-win/schedules/{scheduleId}/end`;
        urlPath = urlPath.replace(`{${"scheduleId"}}`, encodeURIComponent(String(requestParameters['scheduleId'])));
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * End a prize schedule that has started, effective now. Players stop receiving it immediately, and prizes that have not unlocked yet are never awarded.
     */
    async endRewardScheduleEarly(requestParameters: EndRewardScheduleEarlyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.endRewardScheduleEarlyRaw(requestParameters, initOverrides);
    }

    /**
     * Return every Spin-to-Win prize schedule that has not yet ended, including schedules that are not ready, each with its S2W game, lifecycle status, and prizes with their post-win configuration
     */
    async getCurrentRewardSchedulesRaw(requestParameters: GetCurrentRewardSchedulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardSchedulesWithGames>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getCurrentRewardSchedules().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:spin-to-win"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/spin-to-win/schedules`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardSchedulesWithGamesFromJSON(jsonValue));
    }

    /**
     * Return every Spin-to-Win prize schedule that has not yet ended, including schedules that are not ready, each with its S2W game, lifecycle status, and prizes with their post-win configuration
     */
    async getCurrentRewardSchedules(requestParameters: GetCurrentRewardSchedulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardSchedulesWithGames> {
        const response = await this.getCurrentRewardSchedulesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Spin outcomes across all players over the last few hours, with the spin to win games.
     */
    async getSpinHealthRaw(requestParameters: GetSpinHealthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SpinHealthWithGames>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getSpinHealth().'
            );
        }

        if (requestParameters['windowHours'] == null) {
            throw new runtime.RequiredError(
                'windowHours',
                'Required parameter "windowHours" was null or undefined when calling getSpinHealth().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['windowHours'] != null) {
            queryParameters['windowHours'] = requestParameters['windowHours'];
        }

        if (requestParameters['gameId'] != null) {
            queryParameters['gameId'] = requestParameters['gameId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:spin-to-win"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/spin-to-win/health`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SpinHealthWithGamesFromJSON(jsonValue));
    }

    /**
     * Spin outcomes across all players over the last few hours, with the spin to win games.
     */
    async getSpinHealth(requestParameters: GetSpinHealthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SpinHealthWithGames> {
        const response = await this.getSpinHealthRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Return a paginated list of a player\'s spin history.  Defaults with all results returned in one page, but future proofed to support paginated results. Can optionally filter by the history for a particular game
     */
    async getSpinHistoryForPlayerRaw(requestParameters: GetSpinHistoryForPlayerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SpinHistoryAdminPage>> {
        if (requestParameters['playerLookupId'] == null) {
            throw new runtime.RequiredError(
                'playerLookupId',
                'Required parameter "playerLookupId" was null or undefined when calling getSpinHistoryForPlayer().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getSpinHistoryForPlayer().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['gameId'] != null) {
            queryParameters['gameId'] = requestParameters['gameId'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['resultStart'] != null) {
            queryParameters['resultStart'] = requestParameters['resultStart'];
        }

        if (requestParameters['resultEnd'] != null) {
            queryParameters['resultEnd'] = requestParameters['resultEnd'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = (requestParameters['startDate'] as any).toISOString();
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = (requestParameters['endDate'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:player-spins"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/spin-to-win/{playerLookupId}/spin/history`;
        urlPath = urlPath.replace(`{${"playerLookupId"}}`, encodeURIComponent(String(requestParameters['playerLookupId'])));
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SpinHistoryAdminPageFromJSON(jsonValue));
    }

    /**
     * Return a paginated list of a player\'s spin history.  Defaults with all results returned in one page, but future proofed to support paginated results. Can optionally filter by the history for a particular game
     */
    async getSpinHistoryForPlayer(requestParameters: GetSpinHistoryForPlayerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SpinHistoryAdminPage> {
        const response = await this.getSpinHistoryForPlayerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Edit a prize schedule that has not ended: promo text, support and rules links, and each listed prize\'s name and post-win configuration. Players see the change immediately.
     */
    async updateRewardScheduleContentRaw(requestParameters: UpdateRewardScheduleContentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardScheduleWithGame>> {
        if (requestParameters['scheduleId'] == null) {
            throw new runtime.RequiredError(
                'scheduleId',
                'Required parameter "scheduleId" was null or undefined when calling updateRewardScheduleContent().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling updateRewardScheduleContent().'
            );
        }

        if (requestParameters['rewardScheduleContentUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'rewardScheduleContentUpdateRequest',
                'Required parameter "rewardScheduleContentUpdateRequest" was null or undefined when calling updateRewardScheduleContent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:spin-to-win"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/spin-to-win/schedules/{scheduleId}/content`;
        urlPath = urlPath.replace(`{${"scheduleId"}}`, encodeURIComponent(String(requestParameters['scheduleId'])));
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RewardScheduleContentUpdateRequestToJSON(requestParameters['rewardScheduleContentUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardScheduleWithGameFromJSON(jsonValue));
    }

    /**
     * Edit a prize schedule that has not ended: promo text, support and rules links, and each listed prize\'s name and post-win configuration. Players see the change immediately.
     */
    async updateRewardScheduleContent(requestParameters: UpdateRewardScheduleContentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardScheduleWithGame> {
        const response = await this.updateRewardScheduleContentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace a Spin-to-Win game\'s settings: name, spin cost, daily spin limit, text limits, theme, and prize reveal method. Players see the change on their next spin.
     */
    async updateS2WGameRaw(requestParameters: UpdateS2WGameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<S2WGame>> {
        if (requestParameters['gameId'] == null) {
            throw new runtime.RequiredError(
                'gameId',
                'Required parameter "gameId" was null or undefined when calling updateS2WGame().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling updateS2WGame().'
            );
        }

        if (requestParameters['s2WGameUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                's2WGameUpdateRequest',
                'Required parameter "s2WGameUpdateRequest" was null or undefined when calling updateS2WGame().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:spin-to-win"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/spin-to-win/games/{gameId}`;
        urlPath = urlPath.replace(`{${"gameId"}}`, encodeURIComponent(String(requestParameters['gameId'])));
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: S2WGameUpdateRequestToJSON(requestParameters['s2WGameUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => S2WGameFromJSON(jsonValue));
    }

    /**
     * Replace a Spin-to-Win game\'s settings: name, spin cost, daily spin limit, text limits, theme, and prize reveal method. Players see the change on their next spin.
     */
    async updateS2WGame(requestParameters: UpdateS2WGameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<S2WGame> {
        const response = await this.updateS2WGameRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
